import { insightCategoryLabel } from '../api/insights'

const LEVEL_CLS: Record<string, { bar: string; text: string }> = {
  iniciante: { bar: 'bg-slate-400', text: 'text-slate-500' },
  aprendendo: { bar: 'bg-amber-400', text: 'text-amber-700' },
  especialista: { bar: 'bg-brand-500', text: 'text-brand-700' },
  ultra: { bar: 'bg-emerald-500', text: 'text-emerald-700' },
}

/**
 * Nível de conhecimento da IA sobre um cliente (0–100): seções-chave do dossiê
 * confirmadas, metas, contexto do negócio e retorno recente do gerente.
 */
export function KnowledgeMeter({
  score,
  level,
  label,
  missingSections = [],
  compact = false,
}: {
  score: number
  level: string
  label: string
  missingSections?: string[]
  compact?: boolean
}) {
  const cls = LEVEL_CLS[level] ?? LEVEL_CLS.iniciante
  const title = missingSections.length
    ? `Falta no dossiê: ${missingSections.map(insightCategoryLabel).join(', ')}`
    : 'Todas as seções-chave do dossiê têm fatos confirmados'
  return (
    <div className={compact ? 'min-w-[120px]' : 'min-w-[160px]'} title={title}>
      <div className="flex items-center justify-between gap-2 text-[11px]">
        <span className={`font-semibold ${cls.text}`}>{label}</span>
        <span className="tabular-nums text-slate-400">{score}</span>
      </div>
      <div className="mt-1 h-1.5 overflow-hidden rounded-full bg-slate-100">
        <div className={`h-full rounded-full ${cls.bar} transition-all`} style={{ width: `${Math.max(3, score)}%` }} />
      </div>
    </div>
  )
}
